import ReceiptItem from './ReceiptItem';

export default ReceiptItem;
